import styled from 'styled-components';
import {
  spacing, containers
} from '@comicrelief/component-library';

const Wrapper = styled.div`
  background: ${({ theme }) => theme.color('grey_light')};
  display: flex;
  flex-direction: column;
`;

const Container = styled.article.attrs({
  'data-test': 'default'
})`
  background: ${({ theme }) => theme.color('white')};
  width: 100%;
  max-width: ${containers.small};
  margin: ${spacing('l')} auto;
  padding: ${spacing('md')};
  @media ${({ theme }) => theme.allBreakpoints('M')} {
    padding: ${spacing('l')} ${spacing('xl')};
  }
`;

const Header = styled.header`
  padding-top: ${spacing('l')};
  text-align: center;
  width: 100%;
  max-width: ${containers.small};
  margin: 0 auto;
`;

export { Wrapper, Container, Header };
